import axiosInstance from './axios';
import { AuditLogsParams, AuditLogsResponse } from 'types/auditLog';

export const auditLogsService = {
  getAuditLogs: async (params: AuditLogsParams): Promise<AuditLogsResponse> => {
    const response = await axiosInstance.get('/admin/audit-logs', { params });
    return response.data;
  },
  getAuditLogEntry: async (key: string): Promise<any> => {
    const response = await axiosInstance.get('/admin/audit-logs/entry', {
      params: { key },
    });
    return response.data;
  },
  getDownloadUrl: async (key: string): Promise<{ data: { url: string } }> => {
    const response = await axiosInstance.get('/admin/audit-logs/download', {
      params: { key },
    });
    return response.data;
  },
};
